import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ disabled: boolean }>()(
  (theme, { disabled }) => ({
    inputContainer: {
      width: '100%',
      '.MuiOutlinedInput-root': {
        minHeight: 'unset'
      }
    },
    displayContainer: {
      alignItems: 'center',
      border: '1px solid transparent',
      borderRadius: theme.shape.borderRadius,
      cursor: disabled ? 'default' : 'text',
      display: 'flex',
      gap: theme.spacing(1),
      justifyContent: 'space-between',
      marginLeft: theme.spacing(-0.5),
      paddingBottom: theme.spacing(0.25),
      paddingLeft: theme.spacing(0.5),
      paddingTop: theme.spacing(0.25),
      width: '100%',
      ...(!disabled && {
        '&:hover': {
          borderColor: theme.vars.palette.divider
        },
        '&:hover .inline-edit-icon': {
          opacity: 1
        }
      })
    },
    valueText: {
      fontWeight: 700,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    editIcon: {
      opacity: 0,
      transition: 'opacity 0.2s'
    }
  })
);

export default useStyles;
